// extracted by mini-css-extract-plugin
export default {"content":"Content__content--2qj"};